import styled from 'styled-components';

import theme from '../../styles/theme';

export const Container = styled.div`
  display: flex;
  flex: 1;
  height: auto;
  background-color: ${theme.faqBrackground};
  flex-direction: column;
  align-items: center;
  position: relative;
`;

export const BottomDiv = styled.div`
  position: absolute;
  height: 100px;
  bottom: -1px;
  width: 100%;
  background-color: ${theme.background};
`;

export const TextWrapper = styled.div`
  display: flex;
  flex: 1;
  max-height: 200px;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin: 50px 0;
`;

export const Text = styled.span`
  color: ${theme.background};
  font-weight: normal;
  font-size: 32px;
  text-align: center;
  margin: 0px;

  @media (max-width: 960px) {
    font-size: 24px;
  }
`;

export const TextHighlight = styled.mark`
  display: flex;
  color: ${theme.background};
  font-weight: bold;
  font-size: 32px;
  text-align: center;
  margin: 80px 0;
  background-color: transparent;
`;

export const AccordionWrapper = styled.div`
  display: inline-flex;
  flex: 1;
  background-color: ${theme.accent};
  border-radius: 10px;
  padding: 10px 30px;
  flex-direction: column;
  z-index: 2;
  max-width: 760px;
  min-width: 800px;

  @media (max-width: 1024px) {
    margin: 15px;
    min-width: unset;
  }
`;

export const Accordion = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  cursor: pointer;
  height: auto;
  padding: 50px 0;
  border-bottom: 1px solid ${theme.inputBackground};
`;

export const AccordionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: ${({ visible }) => (visible ? theme.secondary : theme.background)};
  font-size: 22px;
  height: 40px;
`;

export const AccordionBody = styled.div`
  display: ${({ visible }) => (visible ? 'flex' : 'none')};
  color: ${theme.background};
  margin-top: 25px;
  align-items: center;
`;

export const Icon = styled.img`
  max-width: 24px;
  rotate: ${({ visible }) => (visible ? '270deg' : '90deg')};
`;

export const Link = styled.a`
  text-decoration: none;
  color: ${theme.background};
`;
